import MarkerClusterer from '@google/markerclustererplus/dist/markerclustererplus.umd';
require('../../assets/images/dealer-locator/dealerActive.svg');
require('../../assets/images/dealer-locator/dealerBronzeActive.svg');
require('../../assets/images/dealer-locator/dealerSilverActive.svg');
require('../../assets/images/dealer-locator/dealerGoldActive.svg');

class DealerLocatorMap {
    constructor (element, options) {
        this.map = {};
        this.geocoder = {};
        this.mapContainer = element;

        const settings = {
            center: null,
            centerLat: null,
            centerLng: null,
            zoom: 6,
            scrollSpeed: 750,
            minZoom: 5,
            maxZoom: 16,
            clusterMaxZoom: 16,
            resetZoom: 5,
            zoomIn: 20,
            zoomOut: 5,
            panControl: false,
            zoomControl: true,
            scrollwheel: false,
            draggable: true,
            clustering: true,
            overviewMapControl: false,
            rotateControl: false,
            autocomplete: [],
            autocompleteInput: [],
            autocompleteLastKey: null,
            autocompleteBoundsMarker: null,
            places: null,
            country: 'Deutschland',
            geolocation: null,
            setAlternativeGeolocation: true,
            disableDoubleClickZoom: false,
            gestureHandling: 'greedy',
            disableDefaultUI: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP // eslint-disable-line no-undef
        };

        this.settings = Object.assign({}, settings, options);

        if (this.settings.centerLat !== null && this.settings.centerLng !== null) {
            this.settings.center = new google.maps.LatLng(this.settings.centerLat, this.settings.centerLng); // eslint-disable-line no-undef
        }

        this.markerImages = [];
        this.mapMarker = [];
        this.locations = marker; // eslint-disable-line no-undef
        this.$mapContainer = document.querySelector('[data-dealer-locator="mapcontainer"]');
        this.$dealerResult = document.querySelector('[data-dealer-locator="results"]');
        this.circle = null;
        this.$locationInput = document.querySelector('[data-input-fill-check]');
        this.$formSubmit = document.querySelector('[data-form-submit]');
        this.$form = document.querySelector('[data-form="result"]');

        this.$noBounds = document.querySelector('[data-no-bounds]');
        this.$inputLAT = document.querySelector('[data-location="lat"]');
        this.$inputLNG = document.querySelector('[data-location="lng"]');
        this.$radius = document.querySelector('[data-select][id="radius"]');

        this.scrollPosition = 0;

        this.markerCluster = [];

        if (document.documentElement.classList.contains('no-csshover')) {
            this.settings.zoom = 5;
        }

        if (document.documentElement.classList.contains('safari')) {
            this.settings.scrollSpeed = 0;
        }

        if (this.mapContainer) {
            this.icons = [{
                url: this.mapContainer.getAttribute('data-mapicon-default'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-default-active'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-cluster'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-bronze'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-bronze-active'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-silver'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-silver-active'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-gold'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-gold-active'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }, {
                url: this.mapContainer.getAttribute('data-mapicon-platinum'),
                size: [30, 40],
                origin: [0, 0],
                anchor: [(30 / 2), [40]]
            }];
        }

        this.initialize();
    }

    initialize () {
        // INIT MAP
        this.map = new google.maps.Map(this.mapContainer, this.settings); // eslint-disable-line no-undef
        this.geocoder = new google.maps.Geocoder; // eslint-disable-line

        // Set Marker Images
        this.setMarkerImages();

        // ADD MARKERS
        if (this.locations !== null) {
            if (this.locations.length > 0) {
                for (let locationIndex = 0; locationIndex < this.locations.length; locationIndex++) {
                    this.addMarker(this.locations[locationIndex]);
                }
            }
        } else {
            console.warn('NO Job-Location where found!!');
        }

        // Center Map with given Coordinates
        this.checkAndSetCenter();

        // Set Cluster for nearby Markers
        this.setCluster(this.markerImages[2].url);

        // Events
        this.setEvents();
    }

    checkAndSetCenter () {
        let center = null;
        const zoom = this.getZoomByMeters((this.$radius.value * 1000));
        if (this.$inputLNG.value !== '' && this.$inputLAT.value !== '') {
            center = new google.maps.LatLng(this.$inputLAT.value, this.$inputLNG.value); // eslint-disable-line
        } else {
            if (this.settings.center !== null) {
                center = this.settings.center;
            }
        }

        if (center) {
            this.map.setCenter(center);
            this.map.setZoom(Math.floor(zoom) - 1);
        }
    }

    setMarkerImages () {
        for (let iconIndex = 0; iconIndex < this.icons.length; iconIndex++) {
            this.markerImages[iconIndex] = {
                url: this.icons[iconIndex].url,
                anchor: new google.maps.Point(parseInt(this.icons[iconIndex].anchor[0]), parseInt(this.icons[iconIndex].anchor[1])), // eslint-disable-line no-undef
                size: new google.maps.Size(parseInt(this.icons[iconIndex].size[0]), parseInt(this.icons[iconIndex].size[1])), // eslint-disable-line no-undef
                origin: new google.maps.Point(parseInt(this.icons[iconIndex].origin[0]), parseInt(this.icons[iconIndex].origin[1])), // eslint-disable-line no-undef
                scaledSize: new google.maps.Size(parseInt(this.icons[iconIndex].size[0]), parseInt(this.icons[iconIndex].size[1])) // eslint-disable-line no-undef
                // optimized: false
            };
        }
    }

    removeVisualRadius () {
        if (this.circle !== null) {
            this.circle.setMap(null); // eslint-disable-line
            this.circle = null;
        }
    }

    setVisualRadius (lat, lng, radius) {
        this.removeVisualRadius();

        this.circle = new google.maps.Circle({ // eslint-disable-line
            strokeColor: '#1371B3',
            strokeOpacity: 0.3,
            strokeWeight: 1,
            fillColor: '#DCEAF4',
            fillOpacity: 0.3,
            map: this.map,
            center: {
                lat: parseFloat(lat),
                lng: parseFloat(lng)
            },
            radius: radius * 1000
        });

        this.circle.addListener('click', () => {
            this.setDealerList(null, 'off');
            this.changeMarker('off');
        });
    }

    selectMapMarkerIcon (status, active) {
        let icon = null;
        if (!status) {
            status = 'default';
        }
        if (active) {
            switch (status) {
            case 'default': icon = this.markerImages[1]; break;
            case 'bronze': icon = this.markerImages[4]; break;
            case 'silver': icon = this.markerImages[6]; break;
            case 'gold': icon = this.markerImages[8]; break;
            case 'platinum': icon = this.markerImages[1]; break;
            }
        } else {
            switch (status) {
            case 'default': icon = this.markerImages[0]; break;
            case 'bronze': icon = this.markerImages[3]; break;
            case 'silver': icon = this.markerImages[5]; break;
            case 'gold': icon = this.markerImages[7]; break;
            case 'platinum': icon = this.markerImages[9]; break;
            }
        }
        return icon;
    }

    addMarker (data) {
        const currentMarker = new google.maps.Marker({ // eslint-disable-line no-undef
            position: new google.maps.LatLng(data.position.lat, data.position.lng), // eslint-disable-line no-undef
            id: data.id,
            lat: data.position.lat,
            lng: data.position.lng,
            map: this.map,
            icon: this.selectMapMarkerIcon(data.status, false),
            status: data.status,
            active: false
        });

        this.mapMarker.push(currentMarker);
        currentMarker.setMap(this.map);

        currentMarker.addListener('click', () => {
            // this.changeClusterIcon('off');
            this.setActiveMarker(currentMarker, false);
        });
    }

    setActiveMarkerWithId (id) {
        this.mapMarker.forEach((marker) => {
            if (parseInt(marker.id) === id) {
                this.setActiveMarker(marker, true);
            }
        });
    }

    setActiveMarker (currentMarker, centerMarker) {
        if (currentMarker.active === false) {
            this.changeMarker('on', currentMarker.id);
            this.setDealerList(currentMarker, 'on');
            if (centerMarker) {
                this.map.panTo(new google.maps.LatLng(currentMarker.lat, currentMarker.lng)); // eslint-disable-line
                this.map.setZoom(12);
            }
        } else {
            this.changeMarker('off');
            this.setDealerList(currentMarker, 'off');
        }
    }

    changeMarker (status, id) {
        if (id) {
            for (let locationsIndex = 0; locationsIndex < this.mapMarker.length; locationsIndex++) {
                if (this.mapMarker[locationsIndex].id === id) {
                    if (status === 'on') {
                        this.mapMarker[locationsIndex].setIcon(this.selectMapMarkerIcon(this.mapMarker[locationsIndex].status, true));
                        this.mapMarker[locationsIndex].active = true;
                    } else {
                        this.mapMarker[locationsIndex].setIcon(this.selectMapMarkerIcon(this.mapMarker[locationsIndex].status, false));
                        this.mapMarker[locationsIndex].active = false;
                    }
                } else {
                    this.mapMarker[locationsIndex].setIcon(this.selectMapMarkerIcon(this.mapMarker[locationsIndex].status, false));
                    this.mapMarker[locationsIndex].active = false;
                }
            }
        } else {
            if (status === 'off') {
                for (let markerIndex = 0; markerIndex < this.mapMarker.length; markerIndex++) {
                    this.changeMarker('off', this.mapMarker[markerIndex].id);
                }
            }
        }
    }

    setCluster (icon) {
        this.markerCluster = new MarkerClusterer(this.map, this.mapMarker, {
            gridSize: 60,
            maxZoom: this.settings.clusterMaxZoom,
            minimumClusterSize: 2,
            zoomOnClick: false,
            averageCenter: true,
            styles: [{
                url: icon,
                width: 30,
                height: 40,
                textLineHeight: 28,
                textColor: '#ffffff',
                textSize: 16
            }]
        });

        setTimeout(() => {
            this.markerCluster.addListener('click', (cluster) => {
                const markers = cluster.getMarkers();

                this.map.fitBounds(cluster.bounds_);
                this.changeMarker('off');
                this.setBounds(markers);
            });
        }, 1000);
    }

    setEvents () {
        this.map.addListener('click', () => {
            this.setDealerList(null, 'off');
            this.changeMarker('off');
        });

        // window.addEventListener('resize', () => this.map.getViewPort().resize()); // eslint-disable-line
    }

    setDealerList (marker, status) {
        window.dealerSlider.slides.forEach((slide, index) => {
            if (status === 'on') {
                if (parseInt(slide.getAttribute('data-dealer-id')) === parseInt(marker.id)) {
                    window.dealerSlider.slideTo(index);
                    slide.classList.add('is--active');
                } else {
                    slide.classList.remove('is--active');
                }
            } else {
                slide.classList.remove('is--active');
            }
        });
    }

    getZoomByMeters (meters) {
        let mapWidth = 0;
        const pixelRatio = window.devicePixelRatio;

        if (this.$mapContainer.clientHeight <= this.$mapContainer.clientWidth) {
            mapWidth = (this.$mapContainer.clientHeight / pixelRatio);
        } else {
            mapWidth = (this.$mapContainer.clientWidth / pixelRatio);
        }

        const lat = this.$inputLAT.value;
        const latitudinalAdjustment = Math.cos(Math.PI * lat / 180.0);
        const arg = 40075004 * mapWidth * latitudinalAdjustment / (meters * 256.0);

        return (Math.log(arg) / Math.log(2.0));
    }

    geocodeLatLng () {
        const newCoordinates = new google.maps.LatLng(this.map.getCenter().lat(), this.map.getCenter().lng()); // eslint-disable-line
        this.$inputLAT.value = this.map.getCenter().lat();
        this.$inputLNG.value = this.map.getCenter().lng();

        const bounds = this.map.getBounds();

        const rad = (x) => {
            return x * Math.PI / 180;
        };

        const getDistance = (p1, p2) => {
            const R = 6378137; // Earth’s mean radius in meter
            const dLat = rad(p2.lat() - p1.lat());
            const dLong = rad(p2.lng() - p1.lng());
            const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(rad(p1.lat())) * Math.cos(rad(p2.lat())) *
                Math.sin(dLong / 2) * Math.sin(dLong / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            const d = R * c;
            let km = Math.ceil((d / 1000) * 0.9);

            if (km < 1) {
                km = 1;
            }

            return km; // returns the distance in km
        };

        this.geocoder.geocode({ location: newCoordinates }, (results, status) => {
            if (status === 'OK') {
                if (results[0]) {
                    let found = false;

                    for (let addressIndex = 0; addressIndex < results[0].address_components.length; addressIndex++) {
                        for (let typeIndex = 0; typeIndex < results[0].address_components[addressIndex].types.length; typeIndex++) {
                            if (results[0].address_components[addressIndex].types[typeIndex] === 'postal_code') {
                                if (found === false) {
                                    found = results[0].address_components[addressIndex].short_name;
                                }
                            }
                        }
                    }
                    if (found !== false) {
                        this.$locationInput.value = found;
                        this.$locationInput.focus();

                        setTimeout(() => {
                            const radiusKM = getDistance(this.map.getCenter(), bounds.getNorthEast());
                            const $dealerSearchRange = document.querySelector('[data-select][id="range"]');

                            const oldRange = $dealerSearchRange.options[$dealerSearchRange.selectedIndex].value;
                            const oldText = $dealerSearchRange.options[$dealerSearchRange.selectedIndex].text;

                            $dealerSearchRange.options[$dealerSearchRange.selectedIndex].value = radiusKM;
                            $dealerSearchRange.options[$dealerSearchRange.selectedIndex].text = radiusKM + 'km';
                            this.$noBounds.value = 1;
                            this.$formSubmit.click();

                            $dealerSearchRange.options[$dealerSearchRange.selectedIndex].value = oldRange;
                            $dealerSearchRange.options[$dealerSearchRange.selectedIndex].text = oldText;
                        }, 1000);
                    }
                } else {
                    console.warn('No results found');
                }
            } else {
                console.warn('Geocoder failed due to: ' + status);
            }
        });
    }

    renewMarker (dealers) {
        this.removeAllMarkers();

        // add new Marker to the map
        if (dealers.length > 0) {
            for (let locationIndex = 0; locationIndex < dealers.length; locationIndex++) {
                this.addMarker(dealers[locationIndex]);
            }
        }
        this.setCluster(this.markerImages[2].url);

        this.checkAndSetCenter();

        // this.setFullscreenHeadline('off');

        if (window.innerWidth < 1024) {
            this.$dealerResult.scrollLeft = 0;
        } else {
            this.$dealerResult.scrollTop = 0;
        }
    }

    removeAllMarkers () {
        // empty Clusters
        this.markerCluster.clearMarkers();

        // remove old Marker
        if (this.mapMarker.length > 0) {
            for (let locationIndex = 0; locationIndex < this.mapMarker.length; locationIndex++) {
                this.mapMarker[locationIndex].setMap(null);
            }
        }

        // empty Array
        this.mapMarker = [];
    }

    setBounds (marker, callback) {
        if (marker.length > 0) {
            const bounds = new google.maps.LatLngBounds(); // eslint-disable-line

            for (let bounceIndex = 0; bounceIndex < marker.length; bounceIndex++) {
                bounds.extend(new google.maps.LatLng(marker[bounceIndex].lat, marker[bounceIndex].lng)); // eslint-disable-line
            }

            this.map.setCenter(bounds.getCenter());
            this.map.fitBounds(bounds);

            setTimeout(() => {
                if (this.map.getZoom() <= 5) {
                    this.map.setZoom(this.settings.resetZoom);
                    console.info('reset map zoom to ' + this.settings.resetZoom);
                }
            }, 500);

            if (typeof callback === 'function') {
                callback();
            }
        } else {
            this.checkAndSetCenter();
        }
    }
}

export { DealerLocatorMap };
